import authService from "../../../auth/AuthService";
import {
    apiActionsBillingGroups,
    apiActionsBillingGroupPricing
} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import {Types, Detail} from "../constants/BillingGroupActionConstants";

const loadAllBillingGroups = (billingGroups) => ({
    type: Types.LOAD_ALL_BILLING_GROUPS_FOR_LIST_PAGE,
    payload: billingGroups,
});

const toggleSortBG = (sortKey) => ({
    type: Types.TOGGLE_BG_SORT,
    payload: sortKey,
});

const fetchAllBGsForListPage = ({authToken}) => ({
    type: apiActionsBillingGroups.GET_ALL_BILLING_GROUPS,
    payload: {authToken}
});

const fetchOneBillingGroup = (billingGroupID, authToken) => ({
    type: apiActionsBillingGroups.GET,
    payload: {billingGroupID, authToken}
});

const fetchOneBillingGroupSuccess = (billingGroupDetail) => ({
    type: Detail.LOAD_BILLING_GROUP_DETAIL,
    payload: {billingGroupDetail},
});

const unmountBillingGroupDetail = () => ({
    type: Detail.CLEAR_BILLING_GROUP_DETAIL_PAGE,
});

const deleteOneBillingGroup = (billingGroupID, authToken) => ({
    type:apiActionsBillingGroups.DELETE,
    payload: {billingGroupID, authToken}
});

const bgGlobalSearch = (value) => ({
    type: Types.BG_GLOBAL_SEARCH,
    payload: value
})

export function billingGroupsTableSearch(value) {
    return (dispatch) => {
        dispatch(bgGlobalSearch(value))
    }
}

export function unmountBillingGroupDetailPage() {
    return (dispatch) => {
        dispatch(unmountBillingGroupDetail());
    }
}

export function fetchBillingGroupDetail(billingGroupID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchOneBillingGroup(billingGroupID, authToken));
    }
}

export function fetchAllBillingGroups() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchAllBGsForListPage({authToken}));
    }
}

export function getAllBillingGroupsSuccess(billingGroups) {
    return (dispatch) => {
        dispatch(loadAllBillingGroups(billingGroups))
    }
}

export function fetchBillingGroupDetailSuccess(billingGroupDetail) {
    return (dispatch) => {
        dispatch(fetchOneBillingGroupSuccess(billingGroupDetail))
    }
}

export function deleteBillingGroup(billingGroupID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteOneBillingGroup(billingGroupID, authToken));
    }
}

export function toggleBGSort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortBG(sortKey))
    }
}

// Billing Group Pricing 
const addBillingGroupPricing = (authToken, pricingSchemeObject) => ({
    type: apiActionsBillingGroupPricing.POST,
    payload: {authToken, pricingSchemeObject}
});

export function addBGPricingCountry(pricingSchemeObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addBillingGroupPricing(authToken, pricingSchemeObject))
    }
}

const editBillingGroupPricing = (authToken, countryPricingID, pricingSchemeObject) => ({
    type: apiActionsBillingGroupPricing.PUT,
    payload: {authToken, countryPricingID, pricingSchemeObject}
});

export function editBGPricingCountry(countryPricingID, pricingSchemeObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editBillingGroupPricing(authToken, countryPricingID, pricingSchemeObject))
    }
}


const exports = {
    Types, 
    Detail,
}

export default exports;